import React, { useEffect, useState } from 'react';


import { useNavigate, Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faDoorOpen, faCalculator, faCalendarAlt, faMapMarkerAlt, aShekelSign } from '@fortawesome/free-solid-svg-icons';

// react icons:
import { IconContext } from "react-icons"
import { BiShekel, BiArea, BiBath, BiMapPin } from "react-icons/bi";
import { RiHotelBedLine, RiRadioButtonLine } from "react-icons/ri";

// MUI Components:
import Box from '@mui/material/Box';

// Styled comp:
import { styled } from '@mui/material/styles';


// model
import {_toLocStringDate}  from '../../../models/formatter';

 /*************************************************************
  * Style Definiton for Component
  ************************************************************/

    /**
     * ITEM 1 : LABEL CURR + NOTE
     */
    const PriceLabel =  styled(Box)({
        color: '#5a5a5a',
        fontWeight:'600',
        padding:'2px',
        borderRadius:'5px',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-around'
    });

    const StatusNote =  styled(Box)({
        float: 'left',
        fontSize: 'small',
        color: '#fcb332'
    });


    const InfoItemCurr = styled(Box) ({
        display:'flex',
        justifyContent:'space-between',
        fontSize:'20px',
        
        [`& ${PriceLabel}`]: {

        },
        [`& ${StatusNote}`]: {

        },
    });


    /**
     * ITEM 2 : FURTHER DETAILS
     */

    const InfoLabel = styled(Box)({
        fontSize:15,
        color: 	'#5a5a5a',
        padding:'0.5rem',
        display:'flex',
        alignItems:'center'
    });

    const InfoItemFurtherDetails = styled(Box) ({
        display:'flex',
        flexDirection:'row',
        justifyContent:'flex-start',
        marginTop:'5px',
        [`& ${InfoLabel}`]: {

        }
    });


    const InfoBarItems = styled(Box) ({
        display:'flex',
        flexDirection:'column',
        listStyleType:'none',
        textAlign:'right',
        padding:'10px',
        [`& ${InfoItemCurr}`]: {

        },

        [`& ${InfoItemFurtherDetails}`]: {
            
        }

    });

    const ObjectInfoBarHolder = styled(Box) ({


    });

function ObjectInfoBar({oObject,onObjDetailPress}) {


    const navigate    = useNavigate();
    const { t, i18n } = useTranslation();

    const handleClick = (oEvent) => {
        onObjDetailPress('objdet',oObject._id, oEvent);
    }

    const onStatusNote = (oEvent) => {
        alert('note')
    }

    return(
            <ObjectInfoBarHolder onClick={handleClick}> 
                <InfoBarItems>
                    <InfoItemCurr>
                        <PriceLabel>
                        <IconContext.Provider value={{ style: { fontSize: '20px', color: "gray" } }}>
                            <BiShekel />
                        </IconContext.Provider>{oObject.price}
                        <Box>{t('object.objectInfo.timeMeasure')}</Box> 
                        </PriceLabel>

                        <StatusNote onClick={onStatusNote}>
                            {/* <IconContext.Provider value={{ style: { fontSize: 'small', color: "#fcb332" } }}>
                                <RiRadioButtonLine />
                            </IconContext.Provider> اعلان تجريبي */}
                            {/* {oObject.postingDate} */}
                            {/* {vPostingDate} */}
                            {_toLocStringDate(oObject.postingDate)}
                            
                        </StatusNote>
                    </InfoItemCurr>

                    <InfoItemFurtherDetails>
                        <InfoLabel>
                             <IconContext.Provider value={{ style: { fontSize: '20px', color: "gray" } }}>
                                 <BiMapPin />
                             </IconContext.Provider>
                            {oObject.city_name}
                        </InfoLabel>
                            
                        <InfoLabel>
                            <RiHotelBedLine />
                            {oObject.numberOfRooms}
                            {t('object.objectInfo.rooms')}
                        </InfoLabel>

                        <InfoLabel>
                             <BiBath />
                             {oObject.numberOfBathrooms}
                             {t('object.objectInfo.bathrooms')}
                        </InfoLabel>

                        <InfoLabel>
                             <BiArea />
                             {oObject.livingSpace}
                             {t('object.objectInfo.unitSizeOfmeasure')}
                        </InfoLabel>


                    </InfoItemFurtherDetails>

                </InfoBarItems>

            </ObjectInfoBarHolder>
    );

}

export default ObjectInfoBar;